<section class="publish-section" aria-labelledby="publish-title">
	<div class="publish-container">
		<div class="publish-text">
			<h2 id="publish-title" class="publish-title">{{ "PublishTitle" | translate}}</h2>
			<ul class="publish-points" role="list">
				<li class="publish-point"><span class="point-text">{{"PublishText1" | translate }}</span></li>
				<li class="publish-point"><span class="point-text">{{ "PublishText2" | translate }}</span></li>
				<li class="publish-point"><span class="point-text">{{ "PublishText3" | translate }}</span></li>
				<li class="publish-point"><span class="point-text">{{ "PublishText4" | translate }}</span></li>
				<li class="publish-point"><span class="point-text">{{ "PublishText5" | translate }}</span></li>
			</ul>
		</div>

		<div class="publish-visual">
			<div class="image-wrapper">
				<img src="/assets/images/image4.webp" width="488" height="304" [alt]="'PUBLISH_TITLE' | translate"  />
			</div>
		</div>

	</div>
	<!-- Structured data: ItemList for publish points -->
	<script type="application/ld+json">
	{
	  "@context": "https://schema.org",
	  "@type": "ItemList",
	  "name": {{ '"' + ("PublishTitle" | translate) + '"' }},
	  "itemListElement": [
	    @if (publishModel.text1) { { "@type": "ListItem", "position": 1, "name": {{ '"' + ('PublishText1' | translate) + '"' }} } },
	    @if (publishModel.text2) { { "@type": "ListItem", "position": 2, "name": {{ '"' + ('PublishText2' | translate) + '"' }} } },
	    @if (publishModel.text3) { { "@type": "ListItem", "position": 3, "name": {{ '"' + ('PublishText3' | translate) + '"' }} } }
	  ]
	}
	</script>
</section>